import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Company } from "../../../model/company";
import { AssessmentTemplateQuestion } from "../../../model/assessment";
import { GENERIC_STATE_STATUS } from "../../../shared/enums";

const initialState: {
  data: Company | null;
  state: GENERIC_STATE_STATUS;
  templateQuestions: AssessmentTemplateQuestion[];
  pending: boolean;
  orgChartCount: number;
  error: { value: boolean; message?: string; code?: string };
} = {
  data: null,
  state: GENERIC_STATE_STATUS.PENDING,
  templateQuestions: [],
  pending: false,
  orgChartCount: 0,
  error: { value: false, message: "" },
};

export const companyStore = createSlice({
  name: "company-reducer",
  initialState,
  reducers: {
    companyFetchStart(state) {
      return { ...state, pending: true, state: GENERIC_STATE_STATUS.PENDING };
    },
    companyFetchSuccess(state, action: PayloadAction<Company>) {
      return {
        ...state,
        pending: false,
        error: { value: false },
        state: GENERIC_STATE_STATUS.FULFILLED,
        data: action.payload,
      };
    },
    companyFetchFail(state) {
      return {
        ...state,
        error: { value: true, message: "Error fetching company" },
        state: GENERIC_STATE_STATUS.REJECTED,
      };
    },
    templateQuestionsFetchStart(state) {
      return { ...state, pending: true, state: GENERIC_STATE_STATUS.PENDING };
    },
    templateQuestionsFetchSuccess(
      state,
      action: PayloadAction<AssessmentTemplateQuestion[]>
    ) {
      return {
        ...state,
        pending: false,
        error: { value: false },
        state: GENERIC_STATE_STATUS.FULFILLED,
        templateQuestions: action.payload,
      };
    },
    templateQuestionsFetchFail(state) {
      return {
        ...state,
        error: { value: true, message: "Error fetching company" },
        state: GENERIC_STATE_STATUS.REJECTED,
      };
    },
    updateOrgChartCount(state, action: PayloadAction<number | null>) {
      if (action.payload) {
        return {
          ...state,
          orgChartCount: state.orgChartCount + action.payload,
        };
      }
      return {
        ...state,
        orgChartCount: 0,
      };
    },
  },
});

export const {
  companyFetchFail,
  companyFetchStart,
  companyFetchSuccess,
  templateQuestionsFetchSuccess,
  updateOrgChartCount,
} = companyStore.actions;
